import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../api';

export default function MyCourses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api('/lms/my-courses').then(r => r.ok ? r.json() : []).then(setCourses).catch(() => {});
  }, []);

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">My Courses</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {courses.map(c => {
          const pct = c.totalPages ? Math.round(c.completedPages / c.totalPages * 100) : 0;
          return (
            <Link key={c.id} to={`/courses/${c.id}`}
              className="bg-white rounded-lg shadow hover:shadow-lg transition p-6 block">
              <h3 className="text-lg font-semibold text-gray-900 mb-1">{c.title}</h3>
              {c.description && <p className="text-gray-500 text-sm mb-4 line-clamp-2">{c.description}</p>}
              <div className="mt-auto">
                <div className="flex justify-between text-sm text-gray-600 mb-1">
                  <span>{c.completedPages}/{c.totalPages} pages</span>
                  <span>{pct}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className={`h-2 rounded-full ${c.completedAt ? 'bg-green-500' : 'bg-indigo-600'}`} style={{width: `${pct}%`}} />
                </div>
                {c.completedAt && (
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-green-600 text-xs font-medium">✓ Completed {new Date(c.completedAt).toLocaleDateString()}</span>
                    <button onClick={async (e) => { e.preventDefault(); const r = await api(`/lms/my-courses/${c.id}/certificate`); if (r.ok) { const blob = await r.blob(); const url = URL.createObjectURL(blob); window.open(url, '_blank'); } }} className="text-xs text-indigo-600 hover:text-indigo-800 font-medium">Download Certificate</button>
                  </div>
                )}
              </div>
            </Link>
          );
        })}
      </div>
      {courses.length === 0 && (
        <div className="bg-white rounded-lg shadow text-center py-12 text-gray-500">No courses assigned to you yet.</div>
      )}
    </Layout>
  );
}
